module.exports = __webpack_public_path__ + "static/media/Metropolis SemiBold-01.bf0f3949.svg";